import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SurveyTemplateService {
  private apiUrl = 'api/survey-templates';

  constructor(private http: HttpClient) { }

  getAllSurveyTemplates(groupId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.get<any>(`${this.apiUrl}/group/${groupId}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  updateSurveyTemplate(templateId: string, templateData: any): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.put<any>(`${this.apiUrl}/${templateId}`, templateData, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }

  resetSurveyTemplate(templateId: string): Observable<any> {
    const token = localStorage.getItem('token');
    return this.http.post<any>(`${this.apiUrl}/${templateId}/reset`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
  }
} 